// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f6482094","239":"f0d0a8f0","453":"27908a62","455":"cc410c2c"}[chunkId] + ".chunk.js";
};